var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Datagrid, DatagridBody, EditButton, List, ShowButton, useCheckMinimumRequiredProps, } from 'react-admin';
import FieldGuesser from './FieldGuesser';
import FilterGuesser from './FilterGuesser';
import Introspecter from './Introspecter';
import Pagination from './list/Pagination';
import useMercureSubscription from './useMercureSubscription';
const displayOverrideCode = (schema, fields) => {
    if (process.env.NODE_ENV === 'production')
        return;
    let code = 'If you want to override at least one field, paste this content in the <ListGuesser> component of your resource:\n\n';
    code += `const ${schema.title}List = props => (\n`;
    code += `    <ListGuesser {...props}>\n`;
    fields.forEach((field) => {
        code += `        <FieldGuesser source={"${field.name}"} />\n`;
    });
    code += `    </ListGuesser>\n`;
    code += `);\n`;
    code += `\n`;
    code += `And don't forget update your <ResourceGuesser> component:\n`;
    code += `<ResourceGuesser name={"${schema.name}"} list={${schema.title}List} />`;
    // eslint-disable-next-line no-console
    console.info(code);
};
export const DatagridBodyWithMercure = (props) => {
    const { resource, ids } = props;
    useMercureSubscription(resource, ids);
    return React.createElement(DatagridBody, Object.assign({}, props));
};
export const IntrospectedListGuesser = (_a) => {
    var { fields, readableFields, writableFields, schema, schemaAnalyzer, rowClick, rowStyle, isRowSelectable, body = DatagridBodyWithMercure, expand, optimized, children } = _a, props = __rest(_a, ["fields", "readableFields", "writableFields", "schema", "schemaAnalyzer", "rowClick", "rowStyle", "isRowSelectable", "body", "expand", "optimized", "children"]);
    const [orderParameters, setOrderParameters] = useState([]);
    useEffect(() => {
        if (schema) {
            schemaAnalyzer.getOrderParametersFromSchema(schema).then((parameters) => {
                setOrderParameters(parameters);
            });
        }
    }, [schema, schemaAnalyzer]);
    let fieldChildren = children;
    if (!fieldChildren) {
        fieldChildren = readableFields.map((field) => {
            const orderField = orderParameters.find((orderParameter) => orderParameter.split('.')[0] === field.name);
            return (React.createElement(FieldGuesser, { key: field.name, source: field.name, sortable: !!orderField, sortBy: orderField, resource: props.resource }));
        });
        displayOverrideCode(schema, readableFields);
    }
    return (React.createElement(List, Object.assign({ pagination: React.createElement(Pagination, null) }, props),
        React.createElement(Datagrid, { rowClick: rowClick, rowStyle: rowStyle, isRowSelectable: isRowSelectable, body: body, expand: expand, optimized: optimized },
            fieldChildren,
            props.hasShow && React.createElement(ShowButton, null),
            props.hasEdit && React.createElement(EditButton, null))));
};
const ListGuesser = (_a) => {
    var { filters = React.createElement(FilterGuesser, null) } = _a, props = __rest(_a, ["filters"]);
    useCheckMinimumRequiredProps('ListGuesser', ['resource'], props);
    if (!props.resource) {
        return null;
    }
    return (React.createElement(Introspecter, Object.assign({ component: IntrospectedListGuesser, resource: props.resource, filters: filters }, props)));
};
/* eslint-disable tree-shaking/no-side-effects-in-initialization */
ListGuesser.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    resource: PropTypes.string.isRequired,
    filters: PropTypes.element,
    hasShow: PropTypes.bool,
    hasEdit: PropTypes.bool,
    rowClick: PropTypes.string,
};
/* eslint-enable tree-shaking/no-side-effects-in-initialization */
export default ListGuesser;
//# sourceMappingURL=ListGuesser.js.map